import { FC } from 'react'

import { Skeleton, Spacer } from '@syconium/little-miss-figgy'

import { Body, Details, Top } from './styles'

// Mirrors `KitCartItem` while the line's product data loads
export const KitCartItemPlaceholder: FC = () => (
  <Body aria-hidden data-testid='cart-kit-item-placeholder'>
    <Top>
      <Skeleton animated height='100px' width='100px' />
      <Details>
        <div>
          <Skeleton animated height='18px' maxWidth='180px' />
          <Spacer height={4} />
          <Skeleton animated height='16px' maxWidth='120px' />
        </div>
      </Details>
    </Top>
  </Body>
)
